import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { CompleteAccountModalContext, ModalContext, openCompleteAccountSignUpModal } from '@/redux/modules/modal';
import { EventContext } from '@/redux/modules/analytics';
import {
    isUserAtLeastPartiallyRegistered as isUserAtLeastPartiallyRegisteredSelector,
    isUserLoggedIn,
} from '@/redux/modules/account/user/user.selectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React, { ReactElement, ReactNode } from 'react';

export type ItemPriceGatewayButtonProps = {
    children?: ReactNode;
    itemId: number;
    small?: boolean;
};

const ItemPriceGatewayButton = ({ children, itemId, small }: ItemPriceGatewayButtonProps): ReactElement => {
    const dispatch = useAppDispatch();
    const { formatMessage } = useIntl();
    const isUserAtLeastPartiallyRegistered = useAppSelector(isUserAtLeastPartiallyRegisteredSelector);
    const isUserFullyLoggedIn = useAppSelector(isUserLoggedIn);
    const modalContext = React.useMemo<ModalContext>(
        () => ({
            eventContext: EventContext.seeSoldPrice,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.SeeSoldPrice,
        }),
        [itemId]
    );

    const handleClick = () => {
        if (!isUserFullyLoggedIn) {
            dispatch(openCompleteAccountSignUpModal(modalContext));
        }
    };

    const unregisteredUserContent = (
        <Button
            onClick={handleClick}
            size={small ? 'sm' : 'md'}
        >
            {formatMessage({ id: 'price_gateway_card' })}
        </Button>
    );

    return isUserAtLeastPartiallyRegistered && isUserFullyLoggedIn ? <>{children}</> : unregisteredUserContent;
};

export default React.memo<ItemPriceGatewayButtonProps>(ItemPriceGatewayButton);
